<template>
	<div id="page-master-role-create">
		<vx-card class="mb-base">
			<div class="vx-row">
				<div class="vx-col w-full mt-2 mb-2">
					<vs-input
						name="rolecode"
						label="Kode Role"
						class="w-full"
						v-model="rolecode"
					/>
				</div>
				<div class="vx-col w-full mt-2 mb-2">
					<vs-input name="rolename" label="Nama role" class="w-full" v-model="rolename" />
				</div>
				<div class="vx-col w-full mt-2 mb-2">
					<vs-table stripe :data="listPageAccess" style="width:60%;text-align:left;">
						<template slot="thead">
							<vs-th>Role</vs-th>
							<vs-th>Hak Akses</vs-th>
						</template>

						<template slot-scope="{data}">
							<vs-tr :key="indextr" v-for="(tr, indextr) in data">
								<vs-td :data="data[indextr].roleaccess">{{data[indextr].roleaccess}}</vs-td>
								<vs-td style="text-align:left;">
									<vs-switch v-model="data[indextr].status" style="width:75px; height:27px;">
										<span slot="on">Ya</span>
										<span slot="off">Tidak</span>
									</vs-switch>
								</vs-td>
							</vs-tr>
						</template>
					</vs-table>
				</div>
			</div>
		</vx-card>
		<div class="vx-col w-full">
			<div class="flex flex-end items-start mb-4">
				<vs-button
					class="mr-4 mb-4"
					color="danger"
					@click="$router.push('/user/role/list').catch(() => {})"
				>Batal</vs-button>
				<vs-button class="mr-4 mb-4" icon-pack="feather" @click="onConfirm">Simpan</vs-button>
			</div>
		</div>
	</div>
</template>

<script>
import ref from "@/api/ref.js";
import formsearch from "@/api/form-search.js";
import user from "@/api/user.js";
import tool from "@/tool/form_tool.js";

export default {
	data() {
		return {
			id: this.$route.params.id,
			rolename: "",
			rolecode: "",
			description: "",
			listPageAccess: [],
			listPerm: []
		};
	},
	methods: {
		async firstLoad() {
			const per = await ref.getPermission();
			var templistPageAccess = {};
			var templistPageAccess1 = [];
			if (per.data.data) {
				per.data.data.forEach(function(item) {
					templistPageAccess.id = item.id;
					templistPageAccess.roleaccess =
						item.displayName;
					templistPageAccess.status = false;
					templistPageAccess1.push(
						templistPageAccess
					);
					templistPageAccess = {};
				});
				this.listPageAccess = templistPageAccess1;
			}
			
			if (this.id) {
				const rl = await user.roleGet(this.id);
				let data = rl.data.data[0];
				this.rolename = data.displayName;
				this.rolecode = data.name;
				this.listPerm = data.permissions;
				var tmpagain = this.listPageAccess;

				this.listPageAccess.forEach(function(
					item,
					idx
				) {
					var brk = false;

					data.permissions.forEach(function(
						item1
					) {
						if (
							item1.id == item.id &&
							!brk
						) {
							tmpagain[
								idx
							].status = true;
							brk = true;
						} else {
							brk = false;
						}
					});
				});
				this.listPageAccess = tmpagain;
			}
		},
		onConfirm() {
			this.$vs.dialog({
				type: "confirm",
				color: "warning",
				title: `Konfirmasi`,
				text: "Simpan data ?",
				acceptText: "Ya",
				cancelText: "Tidak",
				accept: this.submitData
			});
		},
		submitData() {
			var temppermission = {};
			var datapermission = [];
			this.listPageAccess.forEach(function(item) {
				if (item.status == true) {
					temppermission.id = item.id;

					datapermission.push(temppermission);
					temppermission = {};
				}
			});

			const data = {
                displayName: this.rolename,
                name: this.rolecode,
				permissions: datapermission
			};

			if (this.id) {
				data.id = this.id;
			}

			let config = {
				headers: {
					"content-type": "application/json"
				}
			};

			user.saveRole(data, config)
				.then(res => {
					if (res.data.status) {
						this.$vs.notify({
							title: "Info",
							time: 3000,
							text:
								"Data telah berhasil di submit",
							color: "success",
							position: "top-right"
						});
						this.$router.push(
							"/user/role/list"
						);
					} else {
						this.$vs.notify({
							title:
								"Terjadi Kesalahan",
							time: 3000,
							text: res.data.message,
							color: "danger",
							position: "top-right"
						});
					}
				})
				.catch(error => {
					if (error.response) {
						this.$vs.notify({
							title:
								"An Error Occured",
							time: 3000,
							text:
								error.response
									.data
									.message,
							color: "danger",
							position: "top-right"
						});
					}
				});
		}
	},
	mounted() {},
	created() {
		this.firstLoad();
	}
};
</script>

<style lang="scss" scoped>
.bordered {
	border-width: 1px;
	border-radius: 4px;
	box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
	margin: 0;
}
.vx-custom-remove-icon {
	text-align: right;
}
.vs-textarea-primary.focusx {
	border: 1px solid #0056a8 !important;
	box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
}
.vs-checkbox-default {
	transform: translate(0, -70%);
	top: 70%;
}
</style>
